module.exports = __webpack_public_path__ + "img/poly-4.0bcde01c.png";